import { Circle, CircleContainer, HorizontalTrackerStepContainer, LeftLine, RightLine } from './styles';
import type { TrackerBarPositionVariant, TrackerBarVariant } from './types';

export interface HorizontalTrackerStepProps {
  barVariant: TrackerBarVariant;
  position: TrackerBarPositionVariant;
  isCurrent: boolean;
}

export const HorizontalTrackerStep = ({ barVariant, position, isCurrent }: HorizontalTrackerStepProps) => {
  return (
    <HorizontalTrackerStepContainer>
      <CircleContainer>
        <Circle variant={barVariant} />
      </CircleContainer>
      {position !== 'last' && (
        <>
          <LeftLine variant={barVariant} isCurrent={isCurrent} />
          <RightLine variant={barVariant} isCurrent={isCurrent} />
        </>
      )}
    </HorizontalTrackerStepContainer>
  );
};
